import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import DHPic from "../../images/Dr-haiel3.png";
import Typewriter from "typewriter-effect";

import { Button, CircularProgress, FormControl, Menu, MenuItem, TextField } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { generateAnswer, generateMoreQuestions, getDKWinResponse } from "../../api/chatgpt";
import { requestMatchedDkws } from "../../api";
import { auth } from "../../config/firebase";
import { addMessage } from "../../api/firebaseStore";


const useStyles = makeStyles({
  root: {
    maxWidth: 500,
  },
  avt: {
    marginBottom: 20,
    "&:before": {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: "30px 30px",
      backgroundRepeat: "no-repeat",
      content: '""',
      position: "absolute",
      left: 10,
      width: 30,
      height: 30,
    },
  },
  bot: {
    maxWidth: "fit-content",
  },
  media: {
    height: 140,
  },
  divider: {
    background: "#1EB0BC",
  },
});

const GPTReply = ({ type, text, inputForGPT, onUserInput }) => {

  const showinputForm = inputForGPT.includes("Ask my own question");


  const classes = useStyles();

  const [gptContent, setGptContent] = useState("...");
  const [loading, setLoading] = React.useState(false);
  const [typewriterEndDisplay, setTypewriterEndDisplay] = React.useState("none");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [moreQuestions, setMoreQuestions] = React.useState([]);
  const [dkwsFound, setDkwsFound] = React.useState([]);

  const [displayForm, setDisplayForm] = React.useState('block');
  //setUserInput
  const [userInput, setUserInput] = React.useState('');

  function handleClick(event) {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClick2(event) {
    if (anchorEl2 !== event.currentTarget) {
      setAnchorEl2(event.currentTarget);
    }
  }

  function handleClose() {
    // console.log("handleClose");
    setAnchorEl(null);
    setAnchorEl2(null);
  }

  const handleSubmit = () => {
    setDisplayForm('none');
    //remove tab,return,emoji ...
    const filteredUserInput = userInput.replace(/(\r\n|\r|\n|\t|[\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, ' ');
    onUserInput('user submit', `I want to know: ${filteredUserInput}`);
  };

  useEffect(() => {
    async function generateGptContent() {
      setLoading(true);
      const xContent = await generateAnswer(inputForGPT);
      console.log("GPT res: ", xContent.data.result);
      addMessage(auth.currentUser ? auth.currentUser.uid : 'unlogin', auth.currentUser ? auth.currentUser.email : '', "GPT_RES", Date.now(), xContent.data.result, '');
      setGptContent(xContent.data.result);

      const moreQuestionsTxt = await generateMoreQuestions(xContent.data.result);
      console.log("GPT moreQuestions: ", moreQuestionsTxt.data.result);
      addMessage(auth.currentUser ? auth.currentUser.uid : 'unlogin', auth.currentUser ? auth.currentUser.email : '', "GPT_MORE_Question", Date.now(), moreQuestionsTxt.data.result, '');
      const moreQs = JSON.parse(moreQuestionsTxt.data.result);
      if (Array.isArray(moreQs)) {
        setMoreQuestions([...moreQs]);
      }

      const dkwTxt = await getDKWinResponse(xContent.data.result);
      console.log("GPT find DKWs: ", dkwTxt.data.result);
      addMessage(auth.currentUser ? auth.currentUser.uid : 'unlogin', auth.currentUser ? auth.currentUser.email : '', "GPT_DKWs_FOUND", Date.now(), dkwTxt.data.result, '');
      const dkws = JSON.parse(dkwTxt.data.result);
      if (Array.isArray(dkws)) {
        const matchedDkws = await requestMatchedDkws(dkws.join("|"));
        console.log("LS filtered DKWs: ", matchedDkws);
        setDkwsFound([...matchedDkws]);
      }

      setLoading(false);
    }
    generateGptContent();
  }, []);

  if (type === "bot") {
    if (text.includes("##")) {
      const textNew = text.substring(0, text.indexOf("##"));
      const other = text.substring(text.indexOf("##") + 2);
      const urltext = other.substring(0, other.indexOf("##"));
      return (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: "20px",
              backgroundColor: "#E3F5F7",
            }}
          >
            <CardContent>
              <Typography
                variant="h5"
                component="h2"
                style={{ fontSize: "1rem" }}
              >
                {" "}
                {textNew}
                <Link href={urltext} target="_blank">
                  Here
                </Link>
              </Typography>
            </CardContent>
          </Card>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: "20px",
              backgroundColor: "#E3F5F7",
            }}
          >
            <CardContent>
              <Typography
                variant="h5"
                component="h2"
                style={{ fontSize: "1rem" }}
              >
                {loading ? (
                  <Box textAlign="center">
                    <CircularProgress />
                  </Box>
                ) : (
                  <Typewriter
                    options={{
                      cursor: " ",
                      delay: 10,
                    }}
                    onInit={(typewriter) => {
                      typewriter.typeString(gptContent).callFunction(() => {
                        setTypewriterEndDisplay("block");
                      }).start();
                    }}
                  />

                )}
              </Typography>
              {
                loading ? <div></div> :
                  <div style={{ display: typewriterEndDisplay }}>
                    {/* form to submit when user say "I want to ask my own question" */}
                    {
                      !showinputForm ? <div></div> : <div style={{ display: displayForm }}>
                        <FormControl className={classes.margin} style={{ width: '100%' }}>
                          <TextField
                            style={{ marginRight: 8, marginLeft: 8, marginBottom: 16, marginTop: 8 }}
                            label="Please Input"
                            variant="outlined"
                            multiline
                            minRows={3}
                            onChange={(e) => {
                              setUserInput(e.target.value);
                            }}
                          />
                        </FormControl>
                        <br />
                        <FormControl className={classes.margin}>
                          <Button
                            style={{ marginLeft: 8, marginBottom: 16 }}
                            variant="contained"
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                        </FormControl>
                      </div>}
                    {/* suggestions */}
                    {
                      showinputForm ? <div></div> :
                        <div style={{ display: displayForm }}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Button
                              aria-owns={anchorEl ? "simple-menu" : undefined}
                              aria-haspopup="true"
                              onClick={handleClick}
                              // onMouseOver={handleClick}
                              style={{
                                margin: 3,
                                color: '#1EB0BC',
                                textDecoration: 'underline'
                              }}
                            >
                              Choose navigation options   +
                            </Button>
                            <Menu
                              id="simple-menu"
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleClose}
                              MenuListProps={{ onMouseLeave: handleClose }}
                            >
                              <MenuItem onClick={() => {
                                handleClose();
                                onUserInput('user submit', `Help select hospitals${dkwsFound[0] ? ' for ' + dkwsFound[0] : ''}`);
                              }}>
                                {`Find hospitals${dkwsFound[0] ? ' for ' + dkwsFound[0] : ''}`}
                              </MenuItem >

                              {dkwsFound[1] && <MenuItem onClick={() => {
                                handleClose();
                                onUserInput('user submit', `Help select hospitals${dkwsFound[1] ? ' for ' + dkwsFound[1] : ''}`);
                              }}>
                                {`Find hospitals${dkwsFound[1] ? ' for ' + dkwsFound[1] : ''}`}
                              </MenuItem >
                              }

                              {dkwsFound[2] && <MenuItem onClick={() => {
                                handleClose();
                                onUserInput('user submit', `Help select hospitals${dkwsFound[2] ? ' for ' + dkwsFound[2] : ''}`);
                              }}>
                                {`Find hospitals${dkwsFound[2] ? ' for ' + dkwsFound[2] : ''}`}
                              </MenuItem >
                              }

                              <MenuItem onClick={() => {
                                handleClose();
                                onUserInput('user submit', `Find doctors nearby`);
                              }}>Find doctors nearby</MenuItem>
                            </Menu>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                onUserInput('user submit', `Ask my own question`);
                              }}
                              style={{
                                textDecoration: 'underline',
                                margin: 3,
                                color: '#1EB0BC'
                              }}
                            >
                              Another question
                            </Link>
                            <Button
                              aria-owns={anchorEl2 ? "simple-menu2" : undefined}
                              aria-haspopup="true"
                              onClick={handleClick2}
                              // onMouseOver={handleClick2}
                              style={{
                                margin: 3,
                                color: '#1EB0BC',
                                textDecoration: 'underline'
                              }}
                            >
                              Related questions   +
                            </Button>
                            <Menu
                              id="simple-menu2"
                              anchorEl={anchorEl2}
                              open={Boolean(anchorEl2)}
                              onClose={handleClose}
                              MenuListProps={{ onMouseLeave: handleClose }}
                            >
                              {
                                moreQuestions.map((question) => <MenuItem onClick={() => {
                                  handleClose();
                                  onUserInput('user submit', question);
                                }}>{question}</MenuItem>)
                              }
                            </Menu>
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => {
                                onUserInput('user submit', `Thanks! I am done.`);
                              }}
                              style={{
                                textDecoration: 'underline',
                                margin: 3,
                                color: '#1EB0BC'
                              }}
                            >
                              I am done.
                            </Link>
                          </div>
                        </div>}
                  </div>
              }
            </CardContent>
            <CardActionArea></CardActionArea>
          </Card>
        </Fragment>
      );
    }
  }
  return null;
};

GPTReply.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string,
};

GPTReply.defaultProps = {
  text: "",
};

export default GPTReply;



// WEBPACK FOOTER //
// ./src/components/GPTReply/GPTReply.js